import styled from "styled-components";

export const Container = styled.div`
  top: 0;
  right: 0;
  height: 100vh;
  z-index: 9999;
  padding: 0.5rem;
  position: fixed;
  overflow-y: auto;
  overflow-x: hidden;
  border-left: 1px solid ${({theme}) => theme["line"]};
  background-color: ${({theme}) => theme["container"]};

  ${({theme}) => theme.breakpoints.up("lg")} {
    top: unset;
    right: unset;
    height: unset;
    position: initial;
  }
`;

export const Content = styled.div`
  padding: 1rem 0.5rem;
`;
